import { formatDistanceToNow, format, isWithinInterval, subYears, isYesterday, isToday } from 'date-fns';

export const formatDate = (dateString) => {
  if (!dateString) return 'Never';

  // Convert UTC date string to local Date object, only append Z if not already present
  const date = new Date(dateString.endsWith('Z') ? dateString : dateString + 'Z');
  const now = new Date();
  const oneYearAgo = subYears(now, 1);

  if (isToday(date)) {
    return 'today';
  }

  if (isYesterday(date)) {
    return 'yesterday';
  }

  if (isWithinInterval(date, { start: oneYearAgo, end: now })) {
    return formatDistanceToNow(date, { addSuffix: true });
  }

  return format(date, 'MMM d, yyyy');
}; 